AOS.init({
  duration: 800,
  once: true,
  disable: function () {
    return window.innerWidth < 768;
  }
});

// Scroll down to next seciton
const btnScrollDown = document.querySelector('#scrollDown');

btnScrollDown.addEventListener('click', () => {
  // Find the parent section (banner/hero) of the button
  let currentSection = btnScrollDown.closest('.landing_hero_main');

  if (!currentSection) return;

  // Find the next visible sibling element
  let nextSection = currentSection.nextElementSibling;

  // Skip hidden elements just in case
  while (nextSection && nextSection.offsetHeight === 0) {
    nextSection = nextSection.nextElementSibling;
  }

  if (nextSection) {
    nextSection.scrollIntoView({ behavior: 'smooth' });
  }
});



// Testimonials slide
document.addEventListener('DOMContentLoaded', function () {
    new Splide('#testim_slider', {
        type: 'loop',
        perPage: 1,
        pagination: false,
        arrows: true,
    }).mount();
});

// Toggle Business Partner answer
document.querySelectorAll('.statitem .stat_title').forEach((title) => {
  title.addEventListener('click', () => {
    title.closest('.statitem').classList.toggle('active');
  });
});




// Get Announcement-bar Height
// function updateAnnouncementHeight() {
//   // Get the announcement custom bar element
//   const announcementBar = document.querySelector('.js-anmb-section');
//   // Check if the element exists
//   if (announcementBar) {
//     // Get the height
//     const height = announcementBar.offsetHeight;
//     // Set the CSS variable
//     document.documentElement.style.setProperty('--announcement-height', `${height}px`);
//   }
// }
// document.addEventListener("DOMContentLoaded", function() {
//   // Update height when the DOM is fully loaded
//   updateAnnouncementHeight();
//   // Update height on window resize
//   window.addEventListener('resize', updateAnnouncementHeight);
// });

// Add has-hero-banner class to the body if .landing-hero class exists
document.addEventListener('DOMContentLoaded', function() {
  var heroBanner = document.querySelector('.landing-hero');
  if (heroBanner) {
    document.body.classList.add('has-hero-banner');
  }
});

